<template>
  <div class="max-w-[2560px] mx-auto">
    <div>
      <div>
        <navigation-bar></navigation-bar>
      </div>
      <div>
        <header-component
          :img="bannerHeader.image_path"
          :title="getLocalized(bannerHeader, 'title')"
          :detailed="getLocalized(bannerHeader, 'description')"
        ></header-component>
      </div>
      <div>
        <experience-company
          :experience="getLocalized(aboutUsData, 'company_story')"
        ></experience-company>
      </div>
      <div>
        <mission-and-vision
          :mission-description="getLocalized(aboutUsData, 'mission')"
          :mission-image="aboutUsData.mission_image_path"
          :vision-description="getLocalized(aboutUsData, 'vision')"
          :vision-image="aboutUsData.vision_image_path"
        ></mission-and-vision>
      </div>
      <div>
        <core-value></core-value>
      </div>
      <div>
        <why-choose-us></why-choose-us>
      </div>

      <div>
        <contact-us></contact-us>
      </div>
      <div>
        <footer-view></footer-view>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/view/NavigationBar.vue";
import experienceCompany from "@/components/AboutUsComponent/experienceCompany.vue";
import missionAndVision from "@/components/AboutUsComponent/missionAndVision.vue";
import CoreValue from "../components/AboutUsComponent/coreValue.vue";
import contactUs from "@/view/contactUsComponent.vue";
import FooterView from "./footerView.vue";
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
import HeaderComponent from "./HeaderComponent.vue";
export default {
  components: {
    NavigationBar,
    experienceCompany,
    missionAndVision,
    CoreValue,
    contactUs,
    FooterView,
    HeaderComponent,
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  data() {
    return {
      aboutUsData: {},
      bannerHeader: {},
      api: process.env.VUE_APP_API_KEY,
    };
  },
  mounted() {
    this.fetchAboutUs();
  },
  methods: {
    async fetchAboutUs() {
      try {
        const response = await axios.get(this.api + "/api/about-us");
        const item = response.data.items[0];
        this.aboutUsData = {
          ...item,
          mission_image_path: `${this.api}${item.mission_image_path}`,
          vision_image_path: `${this.api}${item.vision_image_path}`,
        };
        const reponseSlider = await axios.get(this.api + "/api/sliders");
        this.bannerHeader = reponseSlider.data.items
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .find((item) => item.title_en === "About Us" || item.id === 5);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style></style>
